import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import ConciseAsset from '../../common/ConciseAsset';
import {
  LoadNextSearchPageMsg,
  LoadNextSearchPageQuery,
  SearchMessage,
  SearchQuery
} from '../../autogenerated/ZoomBridge';
import ErrorHandler from '../../error/ErrorHandler';
import ClearSession from '../../queries/session/ClearSession';
import Modal from '../Modal2';
import SpotlightUtil from '../../queries/spotlight/SpotlightUtil';
import t from '../../i18n/I18n';
import { ThemeSetup } from '../../themes/ThemeSetup';

export default class AddSpotlightModal extends React.Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired, // takes argument, success, which returns true if something was added/false if not
    trigger: PropTypes.object
  };

  state = {
    assets: [],
    showingDropdown: false,
    selectedAsset: null,
    searchText: ''
  };

  componentDidMount() {
    if (typeof this.props.asset == 'undefined') {
      this.hasNextPage = true;
      this.loadingAssets = false;
      this.issueQueryForAssets();
      this.delayedIssueQuery = _.debounce((value) => {
        this.issueQueryForAssets(value);
      }, 300);
    }
    this.forceUpdate();
    //ModalTransition.FadeIn(this.refs.modal, this.refs.background);
  }

  loadNextPage() {
    const query = new LoadNextSearchPageQuery();
    const msg = new LoadNextSearchPageMsg();
    msg.setUseBrowseSession(true);
    query.message = msg;
    query.run(false, true).then(
      (resp) => {
        this.handlerResponse(resp, true);
      },
      (error) => {
        this.loadingAssets = false;
        ErrorHandler.handleError(error);
      }
    );
  }

  handlerResponse(resp, concat) {
    this.loadingAssets = false;
    if (_.isEmpty(resp.getResultFiles())) this.hasNextPage = false;
    else {
      this.hasNextPage = true;
      if (concat) this.setState({ assets: this.state.assets.concat(resp.getResultFiles()) });
      else this.setState({ assets: resp.getResultFiles() });
    }
  }

  issueQueryForAssets(value) {
    this.loadingAssets = true;
    const searchQuery = new SearchQuery();
    const msg = new SearchMessage();
    msg.setCreateBrowseSession(true);
    searchQuery.message = msg;
    if (value) {
      msg.setFileName(value);
    }
    searchQuery.run(true).then(
      (resp) => {
        this.handlerResponse(resp, false);
      },
      (error) => {
        this.loadingAssets = false;
        ErrorHandler.handleError(error);
      }
    );
  }

  render() {
    const { onClose } = this.props;
    const modalProps = {
      name: 'AddSpotlightModal',
      title: t('ADD_SPOTLIGHT_TITLE'),
      onClose,
      buttons: [
        { label: t('CANCEL'), type: 'CANCEL', onClick: onClose },
        { label: t('SAVE'), type: 'PRIMARY', onClick: this.addToSpotlight }
      ]
    };

    return (
      <Modal {...modalProps} closeOnEsc={true} closeOnOutsideClick={true}>
        <div>
          <div className="modal-subheader">{t('ASSET')}</div>
          {typeof this.props.asset == 'undefined' ? (
            this.state.selectedAsset == null || this.state.showingDropdown ? (
              <div>
                <input
                  type="text"
                  autoFocus="true"
                  placeholder={t('SEARCH_DOTS')}
                  style={{
                    width: '100%',
                    padding: '.5em',
                    border: 'none',
                    borderRadius: '2px',
                    boxShadow: '0 1px 4px 0 rgba(0,0,0,0.04)',
                    color: 'var(--primary-font-color)',
                    backgroundColor: 'var(--primary-header-bg)'
                  }}
                  onChange={(event) => {
                    this.matchString = event.target.value;
                    window.render();
                    this.delayedIssueQuery(event.target.value);
                  }}
                  value={this.matchString ? this.matchString : ''}
                />
                {this.state.assets.length === 0 && !this.loadingAssets ? (
                  <div style={{ ...styles.asset, color: 'var(--primary-font-color)' }}>{t('NO_RESULT_FOUND')}</div>
                ) : (
                  <div
                    style={{ maxHeight: '250px', overflow: 'auto', margin: '10px 0' }}
                    onScroll={this.onScroll.bind(this)}>
                    {_.map(this.state.assets, (asset) => {
                      return (
                        <ConciseAsset
                          key={asset.getFuid()}
                          style={{ cursor: 'pointer', marginBottom: 5 }}
                          asset={asset}
                          onClick={() => {
                            this.setState({ selectedAsset: asset, showingDropdown: false });
                          }}
                        />
                      );
                    })}
                    {this.loadingAssets ? <div style={styles.loading} /> : null}
                  </div>
                )}
              </div>
            ) : (
              <ConciseAsset
                asset={this.state.selectedAsset}
                style={{ cursor: 'pointer', marginBottom: 10 }}
                onClick={() => {
                  this.setState({ showingDropdown: !this.state.showingDropdown });
                }}>
                <img
                  src="images/arrow_down.svg"
                  style={{ margin: 'auto 10px auto auto', width: '12px', height: '12px' }}
                />
              </ConciseAsset>
            )
          ) : (
            <ConciseAsset asset={this.props.asset} style={{ marginBottom: 10 }} />
          )}
          <div className="modal-subheader">{t('TEXT_OVERLAY')}</div>
          <textarea
            style={{
              padding: '.5em',
              width: '100%',
              height: '100px',
              marginBottom: 0,
              color: 'var(--primary-font-color)',
              backgroundColor: 'var(--primary-header-bg)'
            }}
            ref="assetText"
          />
        </div>
      </Modal>
    );
  }

  addToSpotlight = () => {
    let desc = this.refs.assetText.value;

    if (this.state.selectedAsset == null && typeof this.props.asset == 'undefined') {
      window.setError(t('NO_ASSET_SELECTED'));
    } else {
      this.issueEditSpotLightQuery(
        this.state.selectedAsset == null ? this.props.asset.getFuid() : this.state.selectedAsset.getFuid(),
        desc == null || desc.trim() === '' ? null : desc
      );
    }

    this.closeDialog();
  };

  onScroll(event) {
    const isBottomReached = event.target.scrollTop + event.target.clientHeight === event.target.scrollHeight;
    if (this.hasNextPage && !this.loadingAssets && isBottomReached) this.loadNextPage();
  }

  issueEditSpotLightQuery(fuid, text) {
    SpotlightUtil.addSpotLightQuery(fuid, text);
  }

  closeDialog() {
    this.clearSession();
    //ModalTransition.FadeOut(this.refs.modal, this.refs.background, this.props.onClose.bind(this));
    this.props.onClose(true);
  }

  clearSession() {
    if (this.delayedIssueQuery) {
      new ClearSession(true, false).run();
    }
  }
}

const styles = {
  addModal: {
    position: 'fixed',
    left: '0px',
    top: '0px',
    bottom: '0px',
    right: '0px',
    background: 'rgba(0, 0, 0, 0.2)',
    zIndex: '1',
    display: 'flex'
  },
  selectedOption: {
    margin: 'auto 0.7em',
    color: 'var(--primary-font-color)',
    fontSize: '14px',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  loading: {
    height: 60,
    width: '100%',
    backgroundImage: ThemeSetup.getBackgroundURL('RingSpinner.svg'),
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'contain'
  }
};
